import React from "react";
import { Link } from "react-router-dom";
import { Globe2 } from "lucide-react";
import { ThemeToggle, LanguageMenu } from "@/components/shared/Controls";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden grid-glow border-r border-border">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-transparent" />
        <Link to="/" className="flex items-center gap-2 relative z-10">
          <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
            <Globe2 className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="font-heading font-bold text-lg">GLOBAL PROFIT AI</span>
        </Link>
        <div className="relative z-10 space-y-4">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold leading-tight max-w-md">
            Inteligência comercial global movida por agentes de IA.
          </h2>
          <p className="text-muted-foreground max-w-sm">
            Pesquise mercados, compare preços, analise margens e risco — comece pequeno e escale com controle total do capital.
          </p>
        </div>
        <p className="relative z-10 text-xs text-muted-foreground font-mono">
          Resultados são estimativas. Não há garantia de lucro.
        </p>
      </div>

      <div className="flex flex-col">
        <div className="flex justify-end items-center gap-1 p-4">
          <LanguageMenu />
          <ThemeToggle />
        </div>
        <div className="flex-1 flex items-center justify-center px-6 pb-16">
          <div className="w-full max-w-sm space-y-6 animate-float-up">
            <div className="space-y-1.5">
              <h1 className="font-heading text-2xl font-bold">{title}</h1>
              {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
            </div>
            {children}
            {footer}
          </div>
        </div>
      </div>
    </div>
  );
}
